import request from '../request';
export const insertDynamicTableData = (params) => {
    return request({
        url: '/prod-api/consumer/report/insertDynamicTableData',
        method: 'post',
        body: params,
    });
};
export const updateDynamicTableData = (params) => {
    return request({
        url: '/prod-api/consumer/report/updateDynamicTableData',
        method: 'post',
        body: params,
    });
};
export function getDynamicTableData(body) {
    return request({
        method: 'post',
        url: '/prod-api/consumer/report/getDynamicTableData',
        body,
    });
}
export const getDynamicTableDataDetail = ({ reportId, dataId, flag }) => {
    return request({
        url: `/prod-api/consumer/report/getDynamicTableDataDetail?reportId=${reportId}&dataId=${dataId}${flag ? '&flag=1' : ''}`,
        method: 'get',
    });
};
export const listOtherReport = ({ reportId, type = 5 }) => {
    return request({
        url: `/prod-api/consumer/report/listOtherReport?reportId=${reportId}&type=${type}`,
        method: 'get',
    });
};
export const getCurrentColumnMetadata = (reportId) => {
    return request({
        url: `/prod-api/consumer/report/getCurrentColumnMetadata/${reportId}`,
        method: 'get',
    });
};
export const getDynamicTableDataByColumn = ({ reportId, columnName }) => {
    return request({
        url: `/prod-api/consumer/report/getDynamicTableDataByColumn?reportId=${reportId}&columnName=${columnName}`,
        method: 'get',
    });
};
export function deleteReport(query) {
    return request({
        url: '/prod-api/consumer/report/' + query.reportId,
        method: 'delete',
    });
}
export function addReport(params) {
    return request({
        url: '/prod-api/consumer/report',
        method: 'post',
        body: params,
    });
}
export function modifyReport(query) {
    if (!query.ycPic) {
        query.ysPic = 'base';
    }
    return request({
        url: '/prod-api/consumer/report',
        method: 'put',
        body: query,
    });
}
export const expoortDynamicTableData = (params) => {
    return request({
        url: '/prod-api/consumer/report/expoortDynamicTableData',
        method: 'post',
        body: params,
        file: true,
    });
};
export const getPersonnelInformation = () => {
    return request({
        url: `/prod-api/system/user/list?pageNum=1&pageSize=99999&deptId=1`,
        method: 'get',
    });
};
export const getDeptTree = () => {
    return request({
        url: `/prod-api/system/dept/treeselect`,
        method: 'get',
    });
};
export const getDateSetTree = (params) => {
    return request({
        url: '/prod-api/dataease/datasetTree/treeCateAndTable',
        body: params,
        method: 'post',
    });
};
export const previewData = (id) => {
    return request({
        url: `/prod-api/dataease/datasetTree/previewData?id=${id}`,
        method: 'get',
    });
};
export function treeCateAndTable(params) {
    return request({
        url: '/prod-api/dataease/datasetTree/treeCateAndTable',
        method: 'post',
        body: params,
    });
}
export function listChartViewField(groupId) {
    return request({
        url: `/prod-api/dataease/view/listChartViewField?groupId=${groupId}&chartId=11`,
        method: 'get',
    });
}
export function treeDept(parentId) {
    return request({
        url: `/prod-api/system/dept/treeDept/${parentId}`,
        method: 'get',
    });
}
export function queryUserByParentId({ pageNum, deptId, nickName }) {
    return request({
        url: `/prod-api/system/user/queryUserByParentId?deptId=${deptId}&pageNum=${pageNum}&nickName=${encodeURIComponent(nickName)}&pageSize=20`,
        method: 'get',
    });
}
export function queryUserByIds(params) {
    return request({
        url: `/prod-api/system/user/queryUserByIds`,
        method: 'post',
        body: params,
    });
}
